import React from "react";
import { Tooltip } from "antd";
import { AlignLeftOutlined } from "@ant-design/icons";
import ButtonItem from "./ButtonItem";

// Boton "Desc. larga" del renglon de insumos (Cotizacion, Pedido, Embarque, Venta):
// decide si la descripcion larga del insumo se imprime en el PDF debajo del concepto.
//
// El renglon guarda `imprimirDescripcionLarga` (true/false). Si no lo trae, manda el
// default del catalogo (`insumo.descripcionLargaVenta`). El backend resuelve igual en
// Utils/descripcionLarga.utils.js, que es quien arma el PDF.

const normalizar = (texto) => String(texto || "").trim().toLowerCase();

const LARGO_VISTA_PREVIA = 300;

// Descripcion larga solo si dice algo mas que la corta: muchos insumos traen la misma en
// las dos, y ahi no hay boton.
export const textoDescripcionLarga = (insumoOriginal) => {
    const texto = String(insumoOriginal?.descripcionLarga || "").trim();
    if (!texto || normalizar(texto) === normalizar(insumoOriginal.descripcion)) return undefined;
    return texto;
};

export const imprimeDescripcionLarga = (renglon, insumoOriginal) => {
    const marcado = renglon?.imprimirDescripcionLarga;
    return typeof marcado === "boolean" ? marcado : !!insumoOriginal?.descripcionLargaVenta;
};

// `onToggle(nuevoValor)` recibe el valor que hay que guardar en el renglon.
// `soloLectura`: pantallas Ver*; solo pinta un icono verde cuando se imprime.
const BotonDescripcionLarga = ({ renglon, insumoOriginal, onToggle, soloLectura = false, disabled = false }) => {
    const texto = textoDescripcionLarga(insumoOriginal);
    if (!texto) return null;

    const imprime = imprimeDescripcionLarga(renglon, insumoOriginal);
    if (soloLectura && !imprime) return null;

    const vistaPrevia = texto.length > LARGO_VISTA_PREVIA ? texto.slice(0, LARGO_VISTA_PREVIA) + "…" : texto;
    const titulo = (
        <div style={{ whiteSpace: "pre-line" }}>
            <b>{imprime ? "Se imprime en el PDF:" : "No se imprime en el PDF (clic para imprimir):"}</b>
            {"\n" + vistaPrevia}
        </div>
    );
    const estiloTooltip = { fontSize: "11px", maxWidth: 360 };

    if (soloLectura) {
        return (
            <Tooltip title={titulo} placement="top" overlayInnerStyle={estiloTooltip}>
                <AlignLeftOutlined style={{ fontSize: "18px", color: "#52c41a", cursor: "default" }} />
            </Tooltip>
        );
    }

    return (
        <Tooltip title={titulo} placement="top" overlayInnerStyle={estiloTooltip}>
            {/* El span deja ver el tooltip aunque el boton este deshabilitado */}
            <span style={{ display: "inline-block" }}>
                <ButtonItem
                    type="primary"
                    size="small"
                    icon={<AlignLeftOutlined />}
                    lila2
                    verde={imprime}
                    disabled={disabled}
                    onClick={() => onToggle(!imprime)}
                    lessTime
                />
            </span>
        </Tooltip>
    );
};

export default BotonDescripcionLarga;
